import { Message, MessageType } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { accountConfigurationInfoTranslationKeys } from '../../translations';

const HealthcareProviderAdministratorLackConfigurationMessageContent = (): JSX.Element => {
   return (
      <Message
         type={MessageType.NEGATIVE}
         fullWidth
         displayIndicator
         label={accountConfigurationInfoTranslationKeys.lackOfFullHealthcareProviderConfigurationOnPartAdministrator}
         testId={'lackOfFullHealthcareProviderConfigurationOnPartAdministrator'}
      />
   );
};

type HealthcareProviderAdministratorLackConfigurationStatusProps = {
   readonly healthcareProviderDataConfigured: boolean;
   readonly p1CertificateConfigured: boolean;
};

export const HealthcareProviderAdministratorLackConfigurationStatus = (
   props: HealthcareProviderAdministratorLackConfigurationStatusProps
): JSX.Element | null => {
   if (props.healthcareProviderDataConfigured && props.p1CertificateConfigured) {
      return null;
   }

   return protectFeature(
      'updatingProviderData',
      null,
      <HealthcareProviderAdministratorLackConfigurationMessageContent />
   );
};
